import React from 'react';
import type {FaqCategoryKey} from 'app/utils/knowledgeCenter/categories';
import type {FaqCategorySummary} from 'app/utils/knowledgeCenter/faqGrouping';
import KnowledgeCenterBreadcrumbs from 'app/components/pages/faq/knowledgeCenter/KnowledgeCenterBreadcrumbs';
import KnowledgeCenterCategoryNav from 'app/components/pages/faq/knowledgeCenter/KnowledgeCenterCategoryNav';

interface Props {
    category?: FaqCategoryKey | null;
    categories: FaqCategorySummary[];
    articleTitle?: string;
    layoutVariant?: 'category' | 'article';
    children: React.ReactNode;
}

const KnowledgeCenterArticleLayout = ({
    category,
    categories,
    articleTitle,
    layoutVariant = 'article',
    children
}: Props): React.ReactElement => {
    const layoutClassName = `knowledge-center__article-layout ${layoutVariant === 'category' ? 'knowledge-center__article-layout--category' : ''}`;
    const categoryLabel = category
        ? categories.find(entry => entry.category === category)?.label ?? category
        : '';

    return (
        <div className="knowledge-center knowledge-center--article">
            <div className="knowledge-center__body">
                {category && <KnowledgeCenterBreadcrumbs
                    category={category}
                    categoryLabel={categoryLabel}
                    articleTitle={articleTitle}
                />}
                <div className={layoutClassName}>
                    <KnowledgeCenterCategoryNav
                        categories={categories}
                        activeCategory={category}
                    />
                    {children}
                </div>
            </div>
        </div>
    );
};

export default KnowledgeCenterArticleLayout;
